import { SOB_ANALYTICS_REPORTS_NAMESPACE } from '../../../translations'

const IN_REPORT_NAMESPACE = `${SOB_ANALYTICS_REPORTS_NAMESPACE}--filters`

const getFormattedPeriod = (period?: string) => {
  if (!period) {
    return 'periodless'
  }

  return period.split(',').join('').toLowerCase()
}

export const TRANSLATION_KEYS = {
  filters: {
    obligatoryAll: `${IN_REPORT_NAMESPACE}-obligatory-all`,
    inReport: `${IN_REPORT_NAMESPACE}-in-report`,
    excluded: `${IN_REPORT_NAMESPACE}-excluded`,
    obligatoryAllTooltip: () => `${IN_REPORT_NAMESPACE}-obligatory-all-tooltip`,
    inReportTooltip: (period?: string) =>
      `${IN_REPORT_NAMESPACE}-in-report-${getFormattedPeriod(period)}-tooltip`,
    excludedTooltip: (period?: string) =>
      `${IN_REPORT_NAMESPACE}-excluded-${getFormattedPeriod(period)}-tooltip`,
  },
}
